import { apiClient } from '@/api/client'
import { LEAVE_TYPES, leaveTypeByIdPath } from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'
import type {
  CreateLeaveTypeDto,
  LeaveType,
  UpdateLeaveTypeDto,
} from '@/features/leave/types/leave.types'

export async function listLeaveTypes(includeInactive = false): Promise<LeaveType[]> {
  const { data } = await apiClient.get<ApiResponseWrapper<LeaveType[]>>(LEAVE_TYPES, {
    params: includeInactive ? { includeInactive: 'true' } : undefined,
  })
  return Array.isArray(data?.data) ? data.data : []
}

export async function createLeaveType(body: CreateLeaveTypeDto): Promise<LeaveType> {
  const { data } = await apiClient.post<ApiResponseWrapper<LeaveType>>(LEAVE_TYPES, body)
  const doc = data?.data
  if (!doc?._id) throw new Error('Invalid create leave type response')
  return doc
}

export async function updateLeaveType(
  leaveTypeId: string,
  body: UpdateLeaveTypeDto
): Promise<LeaveType> {
  const { data } = await apiClient.patch<ApiResponseWrapper<LeaveType>>(
    leaveTypeByIdPath(leaveTypeId),
    body
  )
  const doc = data?.data
  if (!doc?._id) throw new Error('Invalid update leave type response')
  return doc
}
